import {
  ApplicationConfig,
  ErrorHandler,
  LOCALE_ID,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { Overlay } from '@angular/cdk/overlay';
import { MAT_DIALOG_SCROLL_STRATEGY } from '@angular/material/dialog';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeFrExtra from '@angular/common/locales/extra/fr';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { TelemetryErrorHandler } from './core/observability/telemetry-error-handler';
import { provideRouterTelemetry } from './core/observability/router-telemetry';

// Enregistre 'fr' (id par défaut du fichier) ET un alias 'fr-FR' pour
// supporter les deux usages dans les pipes date/number/currency.
registerLocaleData(localeFr, undefined, localeFrExtra);
registerLocaleData(localeFr, 'fr-FR', localeFrExtra);

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    provideBrowserGlobalErrorListeners(),
    { provide: ErrorHandler, useClass: TelemetryErrorHandler },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    provideAnimationsAsync(),
    provideRouterTelemetry(),
    // Scroll-block par défaut des MatDialog : il met <html> en `position: fixed`, ce qui —
    // combiné à `html, body { height: 100% }` — décale la sidebar `sticky` du shell quand la
    // page derrière est courte. Le backdrop bloque déjà l'interaction → on passe en `noop`.
    {
      provide: MAT_DIALOG_SCROLL_STRATEGY,
      deps: [Overlay],
      useFactory: (overlay: Overlay) => () => overlay.scrollStrategies.noop(),
    },
  ],
};
